import { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { TextArea } from "@progress/kendo-react-inputs";
import styles from "./DocumentRegister.module.scss";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import {
  addClientDocumentResgisters,
  addMatterDocumentResgisters,
  getDocumentRegisters,
  getMatterRefExample,
  updateDocumentResgister,
} from "api/index";
import { FormComboBox, FormInput, FormDate } from "components/Matters/index";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { CONSTANT } from "CONSTANT/Matter/MatterForm";
import MatterModal from "components/Matters/MatterModal";
import { filterBy } from "@progress/kendo-data-query";

import { ContainerCard } from "components/MatterDetails/ContactCard";
import { DateFormat, DateFormatCell } from "components/common/formatter";
import DataList from "components/MatterDetails/DataList";
import MattersCombobox from "pages/Postings/MattersComboBox";
import { toast } from "react-toastify";
import { Loader } from "@progress/kendo-react-indicators";
import {
  DocRegisterDetailsTab,
  ExecutorsTab,
  ExtraInfoTab,
  TestatorsTab,
} from "./DocRegsiterComponents";
import { useActiveDocTypes } from "services/docTypeService";
import { useActiveFeeEarner } from "services/userService";
import { useCompany } from "services/companyService";
import useMediaQuery from "hooks/useMediaQuery";

const yesNoData = ["Yes", "No"];
const tabs = [
  "Details",
  "Movements",
  "Extra Info",
  "Permanent Out",
  "Notes",
  "Executors",
  "Testator/Owner",
];

const DocumentRegisterModal = (props) => {
  const [isView, setIsView] = useState(props.docId ? true : false);
  const isClient = props.clientId ? true : false;
  const { data: company } = useCompany();
  const [isLoading, setIsLoading] = useState(props.docId ? true : false);
  const [details, setDetails] = useState("");
  const [extraDetails, setExtraDetails] = useState("");
  const [data, setData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalSuccess, setModalSuccess] = useState(undefined);
  const [newMaterId, setNewMatterId] = useState({
    matterId: props?.matterId?.matterId,
    matterRef: props?.matterId?.matterRef,
    matterDetails: props?.matterId?.matterDetails,
  });
  const [closed, setClosed] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [inputState, setInputState] = useState({
    annualFee: null,
  });

  const [comboBoxState, setComboBoxState] = useState({
    [CONSTANT.COMBOBOX.CLIENT]: props.clientId
      ? {
        CustomerID: props.clientId.clientId,
        ContactName: props.clientId.clientName,
        CustomerRef: props.clientId.clientRef,
        display: props.clientId.clientName || props.clientId.clientRef || "",
      }
      : null,
    [CONSTANT.COMBOBOX.SUPERVISIOR]: "",
    [CONSTANT.COMBOBOX.FEE_EARNER]: "",
    [CONSTANT.COMBOBOX.APPLICATION]: "",
    [CONSTANT.COMBOBOX.DEPARTMENT]: "",
    [CONSTANT.COMBOBOX.CATEGORY]: "",
    [CONSTANT.COMBOBOX.BRANCH]: "",
    [CONSTANT.COMBOBOX.DDA_BANK]: "",
    [CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL]: "",
    [CONSTANT.COMBOBOX.CONTACT_LINK]: "",
    docType: "",
  });

  const [dateState, setDateState] = useState({
    [CONSTANT.DATE.START_DATE]: new Date(),
    [CONSTANT.DATE.CLOSED_DATE]: "",
    [CONSTANT.DATE.DELETED_DATE]: "",
    [CONSTANT.DATE.DOB_OS1]: "",
    [CONSTANT.DATE.DOB_OS2]: "",
  });

  const { data: feeEarner } = useActiveFeeEarner();
  const { data: docTypes, loading: docTypesLoading } = useActiveDocTypes();
  useEffect(() => {
    if (docTypes?.length && !isView) {
      setComboBoxState((prev) => ({
        ...prev,
        docType: docTypes.find((item) => item.typeName === data?.typeName),
      }));
    }
  }, [docTypes, isView, data]);

  useEffect(() => {
    if (isView) {
      getDocumentDetails();
    }
  }, [isView]);

  const getDocumentDetails = async () => {
    try {
      const data = await getDocumentRegisters(props.docId);
      setData(data?.data?.data);
      setDetails(data?.data?.data?.details);
      setExtraDetails(data?.data?.data?.extraDetails);
      setInputState({
        [CONSTANT.INPUT.REFERENCE]: data.data.data?.reference || "",
        [CONSTANT.INPUT.LOCATION_CODE]: data.data.data?.location || "",
        ...data?.data?.data,
      });
      const resData = data?.data?.data || {};
      setComboBoxState((prev) => ({
        ...prev,
        [CONSTANT.COMBOBOX.FEE_EARNER]: {
          displayname: resData.feeEarnerName,
          userRef: resData.feeEarnerRef,
        },
        docType: resData.typeName,
        ...(resData.hasOwnProperty("isDeceased") && resData.isDeceased !== null
          ? { isDeceased: resData.isDeceased ? "Yes" : "No" }
          : {}),
        ...(resData.hasOwnProperty("inStorage")
          ? { isStorage: resData.inStorage }
          : {}),
      }));

      setDateState({
        [CONSTANT.DATE.CODICIL_DATE_1]: new Date(data.data?.data?.codicilDate1),
        [CONSTANT.DATE.DATE_OF_DOC]: data.data?.data?.documentDate
          ? new Date(data.data?.data?.documentDate)
          : null,
        [CONSTANT.DATE.CODICIL_DATE_2]: data.data?.data?.codicilDate2
          ? new Date(data.data?.data?.codicilDate2)
          : null,
        [CONSTANT.DATE.LODGEMENT_DATE]: data.data?.data?.lodgementDate
          ? new Date(data.data?.data?.lodgementDate)
          : null,
        [CONSTANT.DATE.REVIEW_DATE]: data.data?.data?.reviewDate
          ? new Date(data.data?.data?.reviewDate)
          : null,
        [CONSTANT.DATE.DATE_OF_WILL]: data.data?.data?.willDate
          ? new Date(data.data?.data?.willDate)
          : null,
        annualFeeDate: data.data?.data?.annualFeeDate
          ? new Date(data.data?.data?.annualFeeDate)
          : null,
        acquiredDate: data.data?.data?.acquiredDate
          ? new Date(data.data?.data?.acquiredDate)
          : null,
      });
    } catch (error) {
    } finally {
      if (isLoading) setIsLoading(false);
    }
  };

  const filterFeeEarner = (filter) => {
    const data = feeEarner.slice();
    return filterBy(data, filter);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const parseDate = (newDate) => {
      if (!newDate) return null;
      var os = newDate?.getTimezoneOffset();
      return (newDate = new Date(newDate.getTime() - os * 60 * 1000));
    };
    const dataObject = {
      ...inputState,
      ...dateState,
      typeId: comboBoxState["docType"]?.docRegisterTypeID,
      typeCode: comboBoxState["docType"]?.code,
      matterRef: newMaterId?.matterRef,
      matterId: newMaterId?.matterId,
      details: details,
      extraDetails: extraDetails,
      reference: inputState[CONSTANT.INPUT.REFERENCE],
      location: inputState[CONSTANT.INPUT.LOCATION_CODE],
      reviewDate: dateState[CONSTANT.DATE.REVIEW_DATE],
      documentDate: dateState[CONSTANT.DATE.DATE_OF_DOC],
      lodgementDate: dateState[CONSTANT.DATE.LODGEMENT_DATE],
      feeEarnerRef: comboBoxState[CONSTANT.COMBOBOX.FEE_EARNER].userRef,
      willDate: dateState[CONSTANT.DATE.DATE_OF_WILL],
      codicilDate1: dateState[CONSTANT.DATE.CODICIL_DATE_1],
      codicilDate2: dateState[CONSTANT.DATE.CODICIL_DATE_2],
      isDeceased: comboBoxState["isDeceased"] === "Yes" ? true : false,
    };
    if (props.docId) {
      try {
        const res = await updateDocumentResgister(
          {
            data: dataObject,
          },
          props.docId,
        );
        if (res?.status === 200) {
          props.updateData();
          toast.success("Doocument Register Updated");
        }
        return;
      } catch (err) { }
    } else {
      try {
        if (props.matterId) {
          const res = await addMatterDocumentResgisters(
            { data: dataObject },
            props.matterId.matterId,
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Document Regsiter added");
          }
        } else if (props.clientId) {
          const res = await addClientDocumentResgisters(
            { data: dataObject },
            props.clientId.clientId,
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Document Regsiter added");
          }
        }
      } catch (err) {
        if (
          err?.response?.data !== "" &&
          err?.response?.data?.errorMessage?.includes(
            "The duplicate key value is",
          )
        ) {
          updateModalState(true, "Matter Ref Already Added", false);
        } else {
          updateModalState(true, "Error Occured", false);
        }
      }
    }
  };

  const [selected, setSelected] = useState(0);
  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const handleModalClose = () => {
    setShowModal(false);
    if (modalSuccess) {
      const myObj = {
        dataItem: {
          matterId: newMaterId,
          matterRef: inputState[CONSTANT.INPUT.MATTER_REF],
          matterDetails: details,
        },
      };
      props.setshowMatterForm();
      if (!props.isView) {
        props.onMatterRefClickActions(myObj);
      }
    }
  };

  const updateModalState = (modalShow, message, success) => {
    setShowModal(modalShow);
    setModalMessage(message);
    setModalSuccess(success);
  };

  const handleInputChange = (value, label) => {
    setInputState({
      ...inputState,
      [label]: value,
    });
  };

  const handleComboBoxChange = (e, label) => {
    setComboBoxState({
      ...comboBoxState,
      [label]: e.value,
    });
  };

  const handleDateChange = (e, label) => {
    setDateState({
      ...dateState,
      [label]: e.value,
    });
  };

  const handleClientChange = async (value) => {
    if (value !== null) {
      try {
        const response = await getMatterRefExample(value.CustomerRef);
        setInputState({
          ...inputState,
          [CONSTANT.INPUT.MATTER_REF]: response.data,
        });
      } catch (error) { }
    }
    setComboBoxState({
      ...comboBoxState,
      [CONSTANT.COMBOBOX.CLIENT]: value,
    });
  };

  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <div>
      <Dialog
        className={`${styles["matter-form-dialog"]} dialog-xxl`}
        title={
          isView
            ? "View Document Register"
            : props.docId
              ? "Edit Document Register"
              : "Add Document Register"
        }
        onClose={props.setshowMatterForm}
      >
        <div
          className=" pb-5 px-5 mt-3"
        >
          {isLoading ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "580px" }}
            >
              <Loader themeColor={"warning"} size={"large"} type={"pulsing"} />
            </div>
          ) : (
            <form id="matterForm" onSubmit={handleSubmit}>
              <ContainerCard
                height={isView ? "115px" : "150px"}
                className="p-3 ps-4 pe-4 pt-2 mb-3 pb-0 overflow-auto"
              >
                <>
                  <div
                    className={`${isView && "pt-2"} container`}
                    style={{ display: !isView && "none" }}
                  >
                    <div className="row px-3">
                      <div className="d-flex align-items-start justify-content-start mt-3">
                        <div className="" style={{ width: "35%" }}>
                          {isClient ? (
                            <DataList
                              text={"Client"}
                              value={data?.clientName}
                              alignItems="align-items-start"
                              keyStyles={{ minWidth: "165px" }}
                            />
                          ) : (
                            <DataList
                              text={"Matter:"}
                              value={data?.matterDetails}
                              alignItems="align-items-start"
                              keyStyles={{ minWidth: "165px" }}
                            />
                          )}
                          <DataList
                            text={"Document Type:"}
                            value={data?.typeName}
                            //
                            alignItems="align-items-start"
                            //
                            keyStyles={{ minWidth: "165px" }}
                          />
                        </div>
                        <div className="ps-5">
                          <DataList
                            text={"Reference:"}
                            value={data?.reference}
                            //
                            alignItems="align-items-start"
                            //
                            keyStyles={{ minWidth: "165px" }}
                          />

                          <DataList
                            text={"Location Code:"}
                            value={data?.location}
                            //
                            alignItems="align-items-start"
                            //
                            keyStyles={{ minWidth: "165px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="container"
                    style={{ display: isView && "none" }}
                  >
                    <div className="d-flex gap-3 gap-xl-4">
                      {isClient ? (
                        <FormComboBox
                          className=""
                          fc={true}
                          name={CONSTANT.COMBOBOX.CLIENT}
                          val={comboBoxState[CONSTANT.COMBOBOX.CLIENT]}
                          onChangeClient={handleClientChange}
                          wf={true}
                          disabled={true}
                          isStyled={true}
                          // className={"mt-3 "}
                          label="Client"
                          width={"260px"}
                          boxShadow={true}
                        />
                      ) : (
                        <div className="d-flex flex-column">
                          <Label className={`label mb-1`}>Matter</Label>
                          <MattersCombobox
                            onChangematter={(e) => {
                              setNewMatterId(e.value);
                            }}
                            value={newMaterId}
                            disabled={true}
                            style={{
                              width: "260px",
                              height: "32px",
                              boxShadow: "0px 1px 9px rgba(0, 0, 0, 0.12)",
                            }}
                          />
                        </div>
                      )}

                      <FormInput
                        required={true}
                        labelWidth
                        wf={true}
                        isStyled={true}
                        // className={"mt-3 "}
                        width={"260px"}
                        boxShadow={true}
                        state={inputState}
                        label={CONSTANT.INPUT.REFERENCE}
                        onChangeInput={handleInputChange}
                      />
                    </div>
                    <div className="mt-3 d-flex gap-3 gap-xl-4">
                      <FormComboBox
                        className=""
                        fc={true}
                        required
                        name={"docType"}
                        loading={docTypesLoading}
                        state={comboBoxState}
                        onChangeComboBox={handleComboBoxChange}
                        wf={true}
                        textField={"typeName"}
                        isStyled={true}
                        disabled={props.docId}
                        data={docTypes}
                        placeholder={"Select Document Type"}
                        label={"Document Type"}
                        width={"260px"}
                      />
                      <FormInput
                        labelWidth
                        wf={true}
                        isStyled={true}
                        // className={"mt-3 "}
                        width={"260px"}
                        // boxShadow={true}
                        state={inputState}
                        label={CONSTANT.INPUT.LOCATION_CODE}
                        onChangeInput={handleInputChange}
                      />
                    </div>
                  </div>
                </>
              </ContainerCard>
              <ContainerCard
                height={"550px"}
                className="p-3 ps-4 pe-4 pt-2 pb-0 overflow-hidden"
              >
                <TabStrip
                  keepTabsMounted={true}
                  selected={selected}
                  onSelect={handleSelect}
                  className="mt-3 pb-4 pagetab w-100"
                  style={{
                    width: "100%",
                  }}
                >
                  {tabs.map((tab, index) => (
                    <TabStripTab
                      key={index}
                      title={
                        <PageTabItemTitle
                          // className="mb-sm-4 mb-xl-0"
                          title={tab}
                          index={index}
                          selected={selected}
                        />
                      }
                    >
                      <div className="mt-4">
                        {tab === "Details" && (
                          <DocRegisterDetailsTab
                            data={data}
                            isView={isView}
                            handleComboBoxChange={handleComboBoxChange}
                            handleDateChange={handleDateChange}
                            comboBoxState={comboBoxState}
                            yesNoData={yesNoData}
                            details={details}
                            setDetails={setDetails}
                            feeEarner={feeEarner}
                            dateState={dateState}
                            locale={company.locale}
                          />
                        )}
                        {tab === "Movements" && (
                          <>
                            {isView ? (
                              <div style={{ display: !isView && "none" }}>
                                <div
                                  className="container pb-2"
                                  style={{ width: "1130px" }}
                                >
                                  <div className="row g-2 mt-3">
                                    <Grid
                                      data={[]}
                                      className={`fs-md ${styles.mattersHeight}`}
                                    >
                                      <GridColumn
                                        field="feeEarner"
                                        title="Fee Earner"
                                        headerClassName="ps-4"
                                        width="240px"
                                      />
                                      <GridColumn
                                        field="code"
                                        title="Code"
                                        width="140px"
                                      />
                                      <GridColumn
                                        field="date"
                                        title="Date In/Out"
                                        width="140px"
                                        cell={DateFormatCell}
                                      />
                                      <GridColumn
                                        field="expectedDate"
                                        title="Expected"
                                        cell={DateFormatCell}
                                        width="140px"
                                      />
                                      <GridColumn
                                        field="description"
                                        title="Description"
                                      />
                                    </Grid>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                        {tab === "Extra Info" && (
                          <ExtraInfoTab
                            data={data}
                            isView={isView}
                            handleDateChange={handleDateChange}
                            inputState={inputState}
                            handleInputChange={handleInputChange}
                            dateState={dateState}
                            extraDetails={extraDetails}
                            setExtraDetails={setExtraDetails}
                            locale={company.locale}
                          />
                        )}
                        {tab === "Permanent Out" && (
                          <>
                            {isView ? (
                              <div style={{ display: !isView && "none" }}>
                                <div
                                  className="container pb-2"
                                  style={{ width: "1130px" }}
                                >
                                  <div className="row g-2 mt-3">
                                    <div className="col">
                                      <div className="container">
                                        <div className="row">
                                          <div className="d-flex align-items-start justify-content-start mt-3 ps-3">
                                            <div
                                              className=""
                                              style={{ width: "34%" }}
                                            >
                                              <DataList
                                                text={"Sent Out By:"}
                                                value={data?.permanentOut}
                                                //
                                                alignItems="align-items-start"
                                                //
                                                keyStyles={{
                                                  minWidth: "165px",
                                                }}
                                              />

                                              <DataList
                                                text={"Name:"}
                                                value={data?.permanentOutName}
                                                //
                                                alignItems="align-items-start"
                                                //
                                                keyStyles={{
                                                  minWidth: "165px",
                                                }}
                                              />

                                              <DataList
                                                text={"Phone No:"}
                                                value={data?.permanentOutPhone}
                                                //
                                                alignItems="align-items-start"
                                                //
                                                keyStyles={{
                                                  minWidth: "165px",
                                                }}
                                              />
                                            </div>
                                            <div className="ps-5">
                                              <DataList
                                                text={"Date Out:"}
                                                value={DateFormat(
                                                  data?.permanentOutDate,
                                                  company.locale,
                                                )}
                                                //
                                                alignItems="align-items-start"
                                                //
                                                keyStyles={{
                                                  minWidth: "165px",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row mt-4 ps-1">
                                          <DataList
                                            text={"Address:"}
                                            className={"mt-1"}
                                            alignItems="align-items-start"
                                            keyStyles={{ minWidth: "165px" }}
                                            value={
                                              <>
                                                {data?.permanentOutAddress
                                                  ?.line1 && (
                                                    <div>
                                                      {
                                                        data?.permanentOutAddress
                                                          ?.line1
                                                      }{" "}
                                                      <br className="mt-1" />
                                                    </div>
                                                  )}
                                                {data?.permanentOutAddress
                                                  ?.town && (
                                                    <div className="mt-1">
                                                      {
                                                        data?.permanentOutAddress
                                                          ?.town
                                                      }{" "}
                                                      <br className="mt-1" />
                                                    </div>
                                                  )}{" "}
                                                {data?.permanentOutAddress
                                                  ?.state && (
                                                    <div className="mt-1">
                                                      {
                                                        data?.permanentOutAddress
                                                          ?.state
                                                      }{" "}
                                                      <br className="mt-1" />
                                                    </div>
                                                  )}{" "}
                                                {data?.permanentOutAddress
                                                  ?.country && (
                                                    <div className="mt-1">
                                                      {
                                                        data?.permanentOutAddress
                                                          ?.country
                                                      }{" "}
                                                      <br className="mt-1" />
                                                    </div>
                                                  )}
                                              </>
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="container pb-2"
                                style={{
                                  width: "1130px",
                                  display: isView && "none",
                                }}
                              >
                                <div className="row g-2 mt-4">
                                  <div className="col">
                                    <div className="container">
                                      <div className="d-flex gap-3 gap-xl-4">
                                        <div className="d-flex flex-column">
                                          <Label className="label mb-1 w-100">
                                            Out By
                                          </Label>
                                          <NumericTextBox
                                            style={{
                                              width: "260px",
                                              height: "32px",
                                            }}
                                            value={inputState["permanentOutBy"]}
                                            onChange={(e) =>
                                              handleInputChange(
                                                e.value,
                                                "permanentOutBy",
                                              )
                                            }
                                            spinners={false}
                                            format="n2"
                                            placeholder="0.00"
                                            className="right-align"
                                          />
                                        </div>
                                        <FormDate
                                          className={styles["date-picker-input"]}
                                          wf={true}
                                          isStyled={true}
                                          width={"260px"}
                                          label={"permanentOutDate"}
                                          customLabel={"Date Out"}
                                          onChangeDate={handleDateChange}
                                          state={dateState}
                                        />
                                      </div>

                                      <FormInput
                                        wf={true}
                                        isStyled={true}
                                        className={"mt-3 "}
                                        ph={"Enter Name"}
                                        width={"260px"}
                                        state={inputState}
                                        label={"permanentOutName"}
                                        labelForComboBox={"Name"}
                                        onChangeInput={handleInputChange}
                                      />

                                      <FormInput
                                        wf={true}
                                        isStyled={true}
                                        className={"mt-3 "}
                                        width={"260px"}
                                        ph={"Enter Number"}
                                        state={inputState}
                                        label={"permanentOutPhone"}
                                        labelForComboBox={"Phone Number"}
                                        onChangeInput={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {tab === "Notes" && (
                          <>
                            {isView ? (
                              <div style={{ display: !isView && "none" }}>
                                <div
                                  className="container pb-2"
                                  style={{ width: "1130px" }}
                                >
                                  <div className="row g-2 mt-3">
                                    <div className="col">
                                      <div className="container">
                                        <div className="row mt-4 px-4">
                                          <p
                                            className={`${styles["notes-text"]}`}
                                          >
                                            {data?.details}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="d-flex flex-column pb-2"
                                style={{
                                  width: "1130px",
                                  display: isView && "none",
                                }}
                              >
                                <Label className={`label mb-1`}>
                                  Notes
                                </Label>
                                <TextArea
                                  placeholder="Enter Details"
                                  autoSize={true}
                                  value={details}
                                  style={{
                                    height: "130px",
                                    minWidth: isDesktop ? "800px" : "700px",
                                  }}
                                  onChange={(e) =>
                                    setDetails(e.value)
                                  }
                                />
                              </div>
                            )}
                          </>
                        )}
                        {tab === "Executors" && (
                          <ExecutorsTab
                            isView={isView}
                            inputState={inputState}
                            handleInputChange={handleInputChange}
                            data={data}
                          />
                        )}
                        {tab === "Testator/Owner" && (
                          <TestatorsTab
                            isView={isView}
                            inputState={inputState}
                            handleInputChange={handleInputChange}
                            data={data}
                          />
                        )}
                      </div>
                    </TabStripTab>
                  ))}
                  {props.isView && (
                    <TabStripTab
                      title={
                        <PageTabItemTitle
                          title="Completion"
                          index={1}
                          selected={selected}
                        />
                      }
                    >
                      <div
                        className="container pb-2"
                        style={{ width: "1130px" }}
                      >
                        <div className="row g-2">
                          <div className="col-6 pt-3">
                            <ContainerCard
                              height={"300px"}
                              className="p-3 ps-4 pe-4 pt-2 pb-0 overflow-auto"
                            >
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ height: "50px" }}
                              >
                                <div className={`${styles["section-title"]}`}>
                                  Completion
                                </div>
                              </div>
                              <hr className="mt-0" />
                              <Checkbox
                                label="Closed"
                                value={closed}
                                onChange={(e) => setClosed(e.value)}
                              />
                              <FormDate
                                disabled={!closed}
                                wf={true}
                                isStyled={true}
                                className={
                                  "mt-3 form-date-picker note-date-picker"
                                }
                                width={"260px"}
                                label={CONSTANT.DATE.CLOSED_DATE}
                                onChangeDate={handleDateChange}
                                state={dateState}
                              />
                              <FormInput
                                state={inputState}
                                className={"mt-3"}
                                wf={true}
                                isStyled={true}
                                width={"260px"}
                                label={CONSTANT.INPUT.LOCATION}
                                onChangeInput={handleInputChange}
                              />
                            </ContainerCard>
                          </div>{" "}
                          <div className="col-6 pt-3">
                            <ContainerCard
                              height={"300px"}
                              className="p-3 ps-4 pe-4 pt-2 pb-0 overflow-auto"
                            >
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ height: "50px" }}
                              >
                                <div className={`${styles["section-title"]}`}>
                                  GDRP
                                </div>
                              </div>
                              <hr className="mt-0" />
                              <Checkbox
                                label="Deleted"
                                onChange={(e) => setDeleted(e.value)}
                              />
                              <FormDate
                                disabled={!deleted}
                                className={
                                  "mt-3 form-date-picker note-date-picker"
                                }
                                wf={true}
                                isStyled={true}
                                width={"260px"}
                                label={CONSTANT.DATE.DELETED_DATE}
                                onChangeDate={handleDateChange}
                                state={dateState}
                              />
                            </ContainerCard>
                          </div>
                        </div>
                      </div>
                    </TabStripTab>
                  )}
                </TabStrip>
              </ContainerCard>
              <button
                id="doc-reg"
                style={{
                  visibility: "hidden",
                }}
                type="submit"
              ></button>
            </form>
          )}
        </div>

        <DialogActionsBar>
          <div className="dialog-footer w-100">
            <Button
              className="common-btn bgBtnSecondary border-0 me-3"
              onClick={props.setshowMatterForm}
            >
              Cancel
            </Button>
            <Button
              className="common-btn me-4"
              type="button"
              form="matterForm"
              onClick={(e) => {
                if (isView) {
                  setIsView(false);
                } else {
                  document.getElementById("doc-reg").click();
                }
              }}
            >
              {isView ? "Edit" : "Save"}
            </Button>
          </div>
        </DialogActionsBar>
      </Dialog >
      <MatterModal
        showModal={showModal}
        message={modalMessage}
        success={modalSuccess}
        onClose={handleModalClose}
      />
    </div >
  );
};

export default DocumentRegisterModal;
